var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{attrs:{"link":"","two-line":""},on:{"click":function($event){return _vm.scrollToElementName();}}},[_c('v-icon',{staticClass:"mr-3"},[_vm._v(_vm._s(_vm.icon))]),_c('v-list-item-content',[_c('span',[_vm._v(_vm._s(_vm.text))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }